import './Exam6FastSearch.scss';
import Combobox2 from '../comm/Combobox2';
import React, { useEffect, useState } from 'react';
import HeaderTitle from '../comm/HeaderTitle';
import fnc from '../mymod/commFunction';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderInfo, setIsBookStudy, setIsFastSearch_saveTest } from '../reduxToolkit/redux';
import HongButton from '../comm/HongButton';

const Exam6FastSearch = ({setIsFastSearch, setSelectedUnitItem}) => {
  const nicePayUrl = process.env.REACT_APP_SERVER_URL_NICEPAY;
  const choJoongGo = useSelector(state => state.reduxStore.choJoongGo);
  const isPaid = useSelector((state) => state.reduxStore.isPaid);
  const userInfo = useSelector((state) => state.reduxStore.userInfo);

  const [teacherId, setTeacherId] = useState('');
  const [initialComboValue1, setInitialComboValue1] = useState();
  const [initialComboValue2, setInitialComboValue2] = useState();
  const [initialComboValue3, setInitialComboValue3] = useState();
  const [initialComboValue4, setInitialComboValue4] = useState('0');
  const [initialComboValue5, setInitialComboValue5] = useState('0');
  const [initialComboValue6, setInitialComboValue6] = useState();

  const [unit1Options, setUnit1Options] = useState([]);
  const [unit2Options, setUnit2Options] = useState([]);
  const [unit3Options, setUnit3Options] = useState([]);
  const [unit4Options, setUnit4Options] = useState([]);
  const [unit5Options, setUnit5Options] = useState([]);
  const [unit6Options, setUnit6Options] = useState([]);
  const [unit7Options, setUnit7Options] = useState([]);
  
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [selectedNodeName, setSelectedNodeName] = useState('');
  const [testList, setTestList] = useState([]);
  const [activeButtons, setActiveButtons] = useState({});
  const dispatch = useDispatch();

  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedBookTitleKey, setSelectedBookTitleKey] = useState(null);
  const [showBtnOrder, setShowBtnOrder] = useState(false);
  const [selectedNodeKey6, setSelectedNodeKey6] = useState(null);

  useEffect(() => {
    // fetchOptions('ROOT', setUnit1Options);
    fncComboRestore();
  }, []);


    useEffect(() => {//복원시 처리
      const unitName = 'unit5';
      const key = fnc.getCookie_pure(`${unitName}_exam`);
      fncHandleBookSelect(key); // 👈 공통 처리
    }, [unit5Options]);
    
    
  
  useEffect(() => {//리스트 복원
    const unitName='unit6_exam';
    const key = fnc.getCookie_pure(unitName);
    const activeItem = unit6Options.filter(pre => pre.childKey === key);
    if (activeItem.length > 0) {
      const nodeKeyValue = activeItem[0].childKey;
      const nodeName = activeItem[0].childName;
      const bookCode = activeItem[0].bookCode;

      fncSelectTestnmList(nodeKeyValue, nodeName, bookCode);
      setSelectedNodeKey6(nodeKeyValue); // ✅ 복원하면서 selectedNodeKey6도 세팅!

    }

  }, [unit6Options])


  function fncComboRestore() {
    let key, unitName;

    fetchOptions('ROOT', setUnit1Options);

    unitName='unit1';
    key = fnc.getCookie_pure(`${unitName}_exam`);

    if (key) {
      fetchOptions_restore(key, setUnit2Options, unitName);
      setInitialComboValue1(key);
    }

    unitName='unit2';
    key = fnc.getCookie_pure(`${unitName}_exam`);

    if (key) {
      fetchOptions_restore(key, setUnit3Options, unitName);
    }

    unitName='unit3';
    key = fnc.getCookie_pure(`${unitName}_exam`);
  
    if (key) {
      fetchOptions_restore(key, setUnit4Options, unitName, true);
    }

    
    unitName='unit4';
    key = fnc.getCookie_pure(`${unitName}_exam`);
    if (key) {
      fetchOptions_restore(key, setUnit5Options, unitName, true);
      setInitialComboValue4(key);
    }
    
    unitName='unit5';
    key = fnc.getCookie_pure(`${unitName}_exam`);
    if (key) {
      fetchOptions_restore(key, setUnit6Options, unitName);
      setInitialComboValue5(key);  
    }

    unitName='unit6';
    key = fnc.getCookie_pure(`${unitName}_exam`);
    if (key) {
      fetchOptions_restore(key, setUnit7Options, unitName);
    }

  }

  //------------복구용
  const fetchOptions_restore = (parentKey, setOptions, unitName, isInsertTitle=false) => {//setOptions은 setUnit1Options의 주소 연결임
    fncSelect_exam_list_fastSearch_restore(parentKey, setOptions, unitName, isInsertTitle);
  };

  const fncSelect_exam_list_fastSearch_restore = (parentKey, setOptions, unitName, isInsertTitle) => {
    const userId = teacherId;

    fnc.sendAxios('/select/exam/fastSearch', { parentKey, userId, choJoongGo }, (res) => {
      if (res && Array.isArray(res)) {

        if(isInsertTitle) {
          const updatedOptions = [{ childKey: '0', childName: '선택하세요' }, ...res];
          setOptions(updatedOptions); 
        } else {
          setOptions(res);
        }

        setActiveButtons(prevState => ({...prevState, [unitName]: parentKey}));
      } else {
        console.log(res, 'kuesbExamRoutes/select/exam/fastSearch');
      }
    });
  };

 
 //------------클릭용
const fetchOptions = (parentKey, setOptions, isInsertTitle=false, unitName = '') => {//setOptions은 setUnit1Options의 주소 연결임
  fncSelect_exam_list_fastSearch(parentKey, setOptions, isInsertTitle, unitName);
};

const fncSelect_exam_list_fastSearch = (parentKey, setOptions, isInsertTitle, unitName) => {
  //st_test_nm_two 여기서 게시 삭제(N)의 경우 단원명(2) 개수가 안 맞게 됨
  const userId = teacherId;

  if (!parentKey) return;

  fnc.sendAxios('/select/exam/fastSearch', { parentKey, userId, choJoongGo }, (res) => {
        console.log(res, 'select/example');
    if (res && Array.isArray(res)) {
         // 선택하세요 옵션을 맨 앞에 추가
        if(isInsertTitle) {
            const updatedOptions = [{ childKey: '0', childName: '선택하세요' }, ...res];
            setOptions(updatedOptions); 

            if(unitName == 'unit3') {
              setInitialComboValue4('0');  
            }else if (unitName == 'unit4') {
              setInitialComboValue5('0');  
            }
    
        } else {
            setOptions(res);
        }
 
    } else {
      console.log(res, 'fncSelect_exam_list_complete');
    }
  });
};



  const handleComboboxChange1 = (option) => {
    handleButtonClick(option.value, option.label, "unit1", setUnit2Options);
  }

  const handleComboboxChange4 = (option) => {
    handleButtonClick(option.value, option.label, "unit4", setUnit5Options);
  }
  const handleComboboxChange5 = (option) => {
    handleButtonClick(option.value, option.label, "unit5", setUnit6Options);
  }



  const handleButtonClick = (key, name, unitName, setOptions) => {
   
    setActiveButtons(prevState => ({
      ...prevState,
      [unitName]: key
    }));


    let isInsertTitle = false;

    switch (unitName) {
      case 'unit3':
      case 'unit4':
        isInsertTitle = true;//선택하세요 추가
        break;
    }
    

    fnc.setCookie_pure(`${unitName}_exam`, key);

    fetchOptions(key, setOptions, isInsertTitle, unitName);


    if(unitName =='unit5') {

      setSelectedNodeKey(key);
      setSelectedNodeName(name);
      setSelectedNodeKey6(null);

      fncHandleBookSelect(key); // 👈 주문교제 확인 공통 처리
    }

    if(unitName =='unit6') {

      setSelectedNodeKey(key);
      setSelectedNodeName(name);
      setSelectedNodeKey6(key);

    }

   


      switch (unitName) {
        case 'unit1':
          setUnit2Options([]);
          setUnit3Options([]);
          setUnit4Options([]);
          setUnit5Options([]);
          setUnit6Options([]);
          setUnit7Options([]);
          setActiveButtons(prevState => ({
            ...prevState,
            unit2: null,
            unit3: null,
            unit4: null,
            unit5: null,
            unit6: null,
            unit7: null
          }));
          fnc.setCookie_pure('unit2_exam', null);
          fnc.setCookie_pure('unit3_exam', null);
          fnc.setCookie_pure('unit4_exam', null);
          fnc.setCookie_pure('unit5_exam', null);
          fnc.setCookie_pure('unit6_exam', null);
          fnc.setCookie_pure('unit7_exam', null);
          break;
        case 'unit2':
          setUnit3Options([]);
          setUnit4Options([]);
          setUnit5Options([]);
          setUnit6Options([]);
          setUnit7Options([]);
          setActiveButtons(prevState => ({
            ...prevState,
            unit3: null,
            unit4: null,
            unit5: null,
            unit6: null,
            unit7: null
          }));
          fnc.setCookie_pure('unit3_exam', null);
          fnc.setCookie_pure('unit4_exam', null);
          fnc.setCookie_pure('unit5_exam', null);
          fnc.setCookie_pure('unit6_exam', null);
          fnc.setCookie_pure('unit7_exam', null);
          break;
        case 'unit3':
          setUnit4Options([]);
          setUnit5Options([]);
          setUnit6Options([]);
          setUnit7Options([]);
          setActiveButtons(prevState => ({
            ...prevState,
            unit4: null,
            unit5: null,
            unit6: null,
            unit7: null
          }));
          fnc.setCookie_pure('unit4_exam', null);
          fnc.setCookie_pure('unit5_exam', null);
          fnc.setCookie_pure('unit6_exam', null);
          fnc.setCookie_pure('unit7_exam', null);
          break;
        case 'unit4':

      
          setUnit5Options([]);
          setUnit6Options([]);
          setUnit7Options([]);
          setActiveButtons(prevState => ({
            ...prevState,
            unit5: null,
            unit6: null,
            unit7: null
          }));
          fnc.setCookie_pure('unit5_exam', null);
          fnc.setCookie_pure('unit6_exam', null);
          fnc.setCookie_pure('unit7_exam', null);
          break;

        case 'unit5':
          setUnit6Options([]);
          setUnit7Options([]);
          setActiveButtons(prevState => ({
            ...prevState,
            unit6: null,
            unit7: null
          }));
          fnc.setCookie_pure('unit6_exam', null);
          fnc.setCookie_pure('unit7_exam', null);
          break;
        case 'unit6':
          setUnit7Options([]);
          setActiveButtons(prevState => ({
            ...prevState,
            unit7: null
          }));
          fnc.setCookie_pure('unit7_exam', null);
          break;
        default:
          break;
      }

  };

  //-------------------------------------------나이스페이 함수
  function fncHandleBookSelect(key) {//클릭과 복원 공통함수
    if (!key || unit5Options.length === 0) return;
  
    const matchedOption = unit5Options.find(opt => opt.childKey === key);
    const price = matchedOption?.price || '';
    const isStore = matchedOption?.isStore == 'Y' || false;

    setSelectedPrice(price);
    setSelectedBookTitleKey(key);
  
    fncSelectIsOrdered(key, price, (isOrdered) => {
      if (isPaid !== 'Y') {//미결제인 경우
        setShowBtnOrder(false);
        return;
      }

      if (isOrdered) {//교사이면서 스토어 교재가 아닌 경우
        setShowBtnOrder(false);//주문버튼 숨김
        return;
      }

      // alert(`isOrdered: ${isOrdered}, isPaid: ${isPaid}, userKind: ${userInfo.kind}, isStore: ${isStore}`);
      
      if (userInfo.kind == 2 && !isStore) {//교사이면서 스토어 교재가 아닌 경우
        setShowBtnOrder(false);
        return;
      } 

      setShowBtnOrder(true);
      
    });
  }
  

  function fncSelectTestnmList(nodeKeyValue, nodeName) {
    const userId = teacherId;
    const stCode = fnc.getCookie('stCode');
    setSelectedNodeKey(nodeKeyValue);
    setSelectedNodeName(nodeName);

    fnc.sendAxios('/select/exam/fastSearch/testName', { nodeKeyValue, userId, stCode }, (res) => {
      if (res && Array.isArray(res)) {
        setTestList(res);
      } else {
        console.log(res, 'kuesbExamRoutes/select/exam/fastSearch/testName');
      }
    });
  };

  function onConfirm() {

    if(!selectedNodeKey) {
      alert('대상이 없습니다.');
      return;
    }


    if(selectedBookTitleKey == 0) {
      alert('교재제목을 선택하세요');
      return;
    }
  

    // kind == 2 (교사)이면 결제 없이 바로 실행
    if (userInfo && userInfo.kind == 2) {
      fncRunConfirm();
      return;
    }

    // kind == 1 (학생)인 경우 기존 결제 로직 실행
    if (isPaid === 'Y') {

      fncSelectIsOrdered(selectedBookTitleKey, selectedPrice, (isOrdered) => {
        if (isOrdered) {
          fncRunConfirm();
        } else {
          alert('교재주문을 하세요!');
        }
      });

  } else {
      fncRunConfirm();
  }

  }

  
  function fncSelectIsOrdered(productCode, price, callback) {
    const id = fnc.getCookie('id');
    const stCode = fnc.getCookie('stCode');
    const certCode = fnc.getCookie('certCode');

    fnc.sendAxios('/kuesbTossOrderRoutes/select/isOrdered', 
        { certCode, id, stCode, productCode }, (res) => {
      if (Array.isArray(res)) {
        if (res.length > 0) {
          const resObj = res[0];
          if (resObj.amount == price && resObj.orderStatus === 'DONE') {
            callback(true);
          } else {
            callback(false);
          }
        } else {
          
          callback(false);  // console.log('✔ 주문 내역이 없습니다. (빈 배열)');
        }
      } else {    
        alert('isOrdered 응답 오류');// console.warn('응답이 배열이 아닙니다. => 에러 상황');
        callback(false);
      }

    });

  };

  function fncRunConfirm() {

    if(!selectedNodeKey6) {
      alert('단원명을 선택하세요.');
      return;
    }

  
    setSelectedUnitItem({value: selectedNodeKey, label: selectedNodeName, bookCode:''});
    dispatch(setHeaderInfo({ title: selectedNodeName, direction: -1 }));
    setIsFastSearch(false);
    dispatch(setIsBookStudy(false));//체크박스 유무(학생이 lms로 들어온 경우)
    dispatch(setIsFastSearch_saveTest(false));
  }


  //=======================================================

  function onNiceOrder() {
    const certCode = fnc.getCookie('certCode');
    const id = fnc.getCookie('id');
    const stCode = fnc.getCookie('stCode');
    const userName = fnc.getCookie('userName');
    const email = fnc.getCookie('email');
    const productCode = selectedBookTitleKey;

    const kind = '진단평가';
    const price = selectedPrice;
    const acaDbName =fnc.getCookie('acaDbName');

    if (!productCode) {
      alert('교재제목을 다시 선택하세요!');
      return;
    }

    if (!price) {
      alert('가격정보가 없습니다!');
      return;
    }

    // window.open('https://kuebs.com/order', '_blank');

    const query = new URLSearchParams({
      certCode,
      id,
      stCode,
      userName,
      email,
      productCode,
      kind,
      acaDbName
    }).toString();
  


    const url = `https://kuebs.com/tossPayDirect?${query}`;
    // const url = `http://localhost:3002/tossPayDirect?${query}`;
    // const url = `${nicePayUrl}/tossPayDirect?${query}`;

    window.open(url, '_blank');

  }

  function onCancel() {
    setIsFastSearch(false);
    dispatch(setIsFastSearch_saveTest(false));
  }

  //=======================================================
  return (
    <div className="Exam6FastSearch">

      <Button className='btnClose-me' onClick={() => setIsFastSearch(false)} >
              <i class="fa-solid fa-xmark"></i>
      </Button> 

      <div className="main">
        <div className="main-inner">
            {false && <div className="boxRect">
              <div className="lblTecId">선생님ID</div>
              <div className="unit1">
                <input
                  type="text"
                  className="txtTeacherID"
                  value={teacherId}
                  onChange={(e) => setTeacherId(e.target.value)}
                />
              </div> 
          </div>}
          <div className='box-cmb1'>
            <Combobox2 className='cmb cmb1' options={unit1Options} handleChange={handleComboboxChange1} initialComboValue={initialComboValue1}/>
            <p className='lbl-cmb1'>이전(다음) → 개정 찾기  제목 클릭</p>
          </div>
          
          <UnitBox label="학년" options={unit2Options} activeKey={activeButtons.unit2} unitName="unit2" onOptionClick={handleButtonClick} setOptions={setUnit3Options} />
          <UnitBox label="과목" options={unit3Options} activeKey={activeButtons.unit3} unitName="unit3" onOptionClick={handleButtonClick} setOptions={setUnit4Options} />
 
          <div className='box-cmb2'>
            <p>제작사</p>
            <Combobox2 className='cmb' options={unit4Options} handleChange={handleComboboxChange4} initialComboValue={initialComboValue4}/>
            <i class="fa-solid fa-arrow-right"></i>
            <p>교재 제목</p>
            <Combobox2 className='cmb' options={unit5Options} handleChange={handleComboboxChange5} initialComboValue={initialComboValue5}/> 
          </div>
          
          <div className='box-danwon'>
            <p className='lbl-danwon'>단원명</p>
            <UnitBox label="단원명" options={unit6Options} activeKey={activeButtons.unit6} unitName="unit6" onOptionClick={handleButtonClick} setOptions={setUnit7Options} />
          </div>
        

          <section className="section-menu-btn">     
              <HongButton className="btn h-btn-dark" iconType={'cancel'}  onClick={onCancel}>취소</HongButton>
              {<HongButton className="btn" iconType={'confirm'} 
              disabled={showBtnOrder} 
              onClick={onConfirm}>확인</HongButton>}
              {showBtnOrder && <HongButton className="btn h-btn-red" iconType={'cart'}  onClick={onNiceOrder}>교재주문</HongButton>}
          </section>
        </div>
      </div>
    </div>
  );
};


// const UnitBox = ({ label, options, activeKey, unitName, onOptionClick, setOptions }) => {

//   return (
//     <div className="boxRect">
//       <div className="lblUnit">{label}</div>
//       <div className="unit">
//         {options.map((option, index) => (
//           <div className='box-btn'>
//             <button
//               key={index}
//               className={`btnUnit ${activeKey === option.childKey ? 'active' : ''}`}
//               onClick={() => onOptionClick(option.childKey, option.childName, unitName, setOptions)}
//             >
//               <div className="childName">
//                 {option.childName} {option.testCnt > 0 ? <span className="testCnt">({option.testCnt})</span> : ""}
//               </div>
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

const UnitBox = ({ label, options, activeKey, unitName, onOptionClick, setOptions }) => {

  return (
    <div className="boxRect">
      <div className="lblUnit">{label}</div>
      <div className="unit">
        {options.map((option) => (
          <div className='box-btn' key={option.childKey}>
            <button
              className={`btnUnit ${activeKey === option.childKey ? 'active' : ''}`}
              onClick={() => onOptionClick(option.childKey, option.childName, unitName, setOptions)}
            >
              <div className="childName">
                {option.childName} {option.testCnt > 0 ? <span className="testCnt">({option.testCnt})</span> : ""}
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Exam6FastSearch;
